// Mock data for Kfz-Sachverständigen Büro

export const companyInfo = {
  name: 'Kfz-Sachverständigen Büro',
  slogan: 'Unabhängig. Präzise. Vertrauenswürdig.',
  description: 'Ihr unabhängiger Partner für professionelle Kfz-Gutachten',
  phone: '+49 (0) 15739251725',
  email: 'info@svb-dueren.com',
  address: 'Heerweg 97, 52353 Düren'
};

export const services = [
  {
    id: 1,
    title: 'Unfallgutachten',
    description: 'Professionelle Bewertung von Unfallschäden für Versicherungen und Privatpersonen. Detaillierte Dokumentation aller Schäden mit präziser Schadenskalkulation.',
    icon: 'FileText'
  },
  {
    id: 2,
    title: 'Wertgutachten',
    description: 'Objektive Fahrzeugbewertung für Kauf, Verkauf oder Versicherung. Ermittlung des aktuellen Marktwerts nach anerkannten Bewertungsverfahren.',
    icon: 'TrendingUp'
  },
  {
    id: 3,
    title: 'Beweissicherung',
    description: 'Umfassende Dokumentation von Fahrzeugzuständen zur rechtlichen Absicherung. Fotodokumentation und technische Analyse für rechtliche Verfahren.',
    icon: 'Camera'
  },
  {
    id: 4,
    title: 'Haftpflichtschaden',
    description: 'Begutachtung von Schäden, die durch Dritte verursacht wurden. Unterstützung bei der Durchsetzung von Schadensersatzansprüchen gegenüber der gegnerischen Versicherung.',
    icon: 'Shield'
  },
  {
    id: 5,
    title: 'Oldtimer-Bewertung',
    description: 'Spezialisierte Wertermittlung für klassische Fahrzeuge. Berücksichtigung von Originalität, Zustand und historischer Bedeutung für Versicherung und Handel.',
    icon: 'Award'
  },
  {
    id: 6,
    title: 'Kaufberatung',
    description: 'Unabhängige Begutachtung vor dem Fahrzeugkauf. Aufdeckung versteckter Mängel und objektive Einschätzung des Fahrzeugzustands zum Schutz vor Fehlkäufen.',
    icon: 'CheckCircle'
  }
];

export const values = [
  {
    id: 1,
    title: 'Objektivität',
    description: 'Als unabhängige Sachverständige sind wir keiner Partei verpflichtet. Unsere Gutachten basieren ausschließlich auf objektiven Fakten und anerkannten technischen Standards.',
    icon: 'Scale'
  },
  {
    id: 2,
    title: 'Transparenz',
    description: 'Klare und nachvollziehbare Gutachten sind unsere Grundlage. Jeder Schritt unserer Bewertung ist dokumentiert und für alle Beteiligten transparent gestaltet.',
    icon: 'Eye'
  },
  {
    id: 3,
    title: 'Zuverlässigkeit',
    description: 'Termingerechte Erstellung und höchste Qualitätsstandards. Unsere Gutachten werden von Versicherungen bundesweit akzeptiert und erfüllen alle erforderlichen Standards.',
    icon: 'BadgeCheck'
  }
];

export const workingProcess = [
  {
    id: 1,
    step: '01',
    title: 'Kontaktaufnahme',
    description: 'Sie kontaktieren uns telefonisch oder über unser Kontaktformular. Wir besprechen Ihr Anliegen und vereinbaren einen Besichtigungstermin, oft noch am selben Tag.'
  },
  {
    id: 2,
    step: '02',
    title: 'Vor-Ort-Begutachtung',
    description: 'Wir kommen zu Ihnen oder zu einem vereinbarten Ort. Die Besichtigung erfolgt gründlich und systematisch mit modernster Technik und umfassender Fotodokumentation.'
  },
  {
    id: 3,
    step: '03',
    title: 'Gutachtenerstellung',
    description: 'Wir erstellen Ihr detailliertes Gutachten schnellstmöglich. Alle relevanten Daten werden präzise erfasst und nach anerkannten Standards ausgewertet.'
  },
  {
    id: 4,
    step: '04',
    title: 'Übergabe & Beratung',
    description: 'Sie erhalten das vollständige Gutachten in digitaler und auf Wunsch in gedruckter Form. Wir stehen für Rückfragen jederzeit zur Verfügung.'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Michael Schmidt',
    text: 'Sehr professionelle und schnelle Abwicklung. Das Gutachten war präzise und wurde von der Versicherung anstandslos anerkannt.',
    rating: 5
  },
  {
    id: 2,
    name: 'Anna Müller',
    text: 'Kompetente Beratung und faire Bewertung meines Oldtimers. Absolut empfehlenswert!',
    rating: 5
  },
  {
    id: 3,
    name: 'Thomas Weber',
    text: 'Dank der Kaufberatung habe ich einen Fehlkauf vermieden. Das Gutachten hat versteckte Mängel aufgedeckt.',
    rating: 5
  }
];
